import { Minus } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function MinusIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Minus
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
